var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"member-wrapper"},[_c('div',{staticClass:"content"},[_c('van-cell',{attrs:{"title":"修改登录密码","is-link":"","to":"edit-pwd"}}),_vm._v(" "),_c('van-cell',{attrs:{"title":"修改手机号/邮箱","is-link":"","to":"edit-phone"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d2c3ee4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/member/account-safety.vue
// module id = null
// module chunks = 